import * as es from "@/lang/es";
import * as en from "@/lang/en";
import * as fr from "@/lang/fr";

export default {
  es,
  en,
  fr,
};
